import {FormControl, MenuItem, TextField} from "@material-ui/core";
import React from "react";

const InputComboBox = (props) => {
    const {
        value,
        field,
        label,
        handleOnChange,
        options,
        errorMessage,
        required,
        menuClass,
        multiple,
        disabled,
        disablePortal,
        disabledOptionIds = [],
    } = props;

    // A select mounted undefined or null stays uncontrolled for life, so a value written later -
    // an imported match filling Suffix - never shows.
    const controlledValue = value ?? (multiple ? [] : '');

    return (
        <FormControl fullWidth>
            <TextField
                select
                fullWidth
                required={required}
                variant='outlined'
                value={controlledValue}
                label={label}
                name={field}
                disabled={disabled || false}
                onChange={handleOnChange}
                error={props.error}
                SelectProps={{
                    MenuProps: {
                        className: menuClass,
                        disablePortal: disablePortal
                    },
                    multiple: multiple
                }}
            >
                <MenuItem value="">
                    <em>Chose an Option</em>
                </MenuItem>
                {
                    options.map((item) => (
                        <MenuItem key={`${field}}-${item.id}`} value={item.id} disabled={disabledOptionIds.includes(item.id)}>
                            {item.name}
                        </MenuItem>
                    ))
                }
            </TextField>
            <span>{errorMessage}</span>
        </FormControl>
    )
}

export default InputComboBox;